import * as React from 'react';
import styled from 'styled-components';

export const Icon = styled.svg.attrs(({ size = 20 }) => ({
  width: size,
  height: size,
  viewBox: '0 0 20 20',
}))`
  position: relative;
  top: -1px;
  color: ${props => props.color};

  vertical-align: middle;

  pointer-events: none;
`;

export const CompanyIcon = styled(Icon).attrs(() => ({
  children: (
    <path
      d="M4-9.375A.376.376,0,0,0,4.375-9h1.25A.376.376,0,0,0,6-9.375v-1.25A.376.376,0,0,0,5.625-11H4.375A.376.376,0,0,0,4-10.625ZM8.375-9h1.25A.376.376,0,0,0,10-9.375v-1.25A.376.376,0,0,0,9.625-11H8.375A.376.376,0,0,0,8-10.625v1.25A.376.376,0,0,0,8.375-9Zm-4,3h1.25A.376.376,0,0,0,6-6.375v-1.25A.376.376,0,0,0,5.625-8H4.375A.376.376,0,0,0,4-7.625v1.25A.376.376,0,0,0,4.375-6Zm4,0h1.25A.376.376,0,0,0,10-6.375v-1.25A.376.376,0,0,0,9.625-8H8.375A.376.376,0,0,0,8-7.625v1.25A.376.376,0,0,0,8.375-6ZM6-3.375v-1.25A.376.376,0,0,0,5.625-5H4.375A.376.376,0,0,0,4-4.625v1.25A.376.376,0,0,0,4.375-3h1.25A.376.376,0,0,0,6-3.375ZM8.375-3h1.25A.376.376,0,0,0,10-3.375v-1.25A.376.376,0,0,0,9.625-5H8.375A.376.376,0,0,0,8-4.625v1.25A.376.376,0,0,0,8.375-3ZM14,.875A.376.376,0,0,0,13.625.5h-.609V-13.25a.748.748,0,0,0-.219-.531A.748.748,0,0,0,12.266-14H1.734a.748.748,0,0,0-.531.219.748.748,0,0,0-.219.531V.5H.375A.376.376,0,0,0,0,.875V2H14ZM2.484.469,2.5-12.5l9.016.031V.469H8V-1.625A.376.376,0,0,0,7.625-2H6.375A.376.376,0,0,0,6-1.625V.469Z"
      transform="translate(3 16)"
      fill="currentColor"
    />
  ),
}))``;

export const EmailIcon = styled(Icon).attrs(() => ({
  children: (
    <path
      d="M14.5-12H1.5A1.5,1.5,0,0,0,0-10.5v9A1.5,1.5,0,0,0,1.5,0h13A1.5,1.5,0,0,0,16-1.5v-9A1.5,1.5,0,0,0,14.5-12Zm0,1.5v1.275c-.7.571-1.818,1.458-4.206,3.328C9.768-5.483,8.725-4.489,8-4.5c-.725.012-1.768-.983-2.294-1.4C3.318-7.767,2.2-8.654,1.5-9.225V-10.5Zm-13,9V-7.3c.716.57,1.732,1.371,3.279,2.583C5.462-4.18,6.658-2.993,8-3s2.516-1.162,3.22-1.717C12.768-5.929,13.784-6.73,14.5-7.3v5.8Z"
      transform="translate(2 16)"
      fill="currentColor"
    />
  ),
}))``;

export const HomeIcon = styled(Icon).attrs(() => ({
  children: (
    <path
      d="M17.82-6.268l-7.7-6.325A2.034,2.034,0,0,0,9-13a2.034,2.034,0,0,0-1.121.406L.18-6.268A.568.568,0,0,0,0-5.885a.58.58,0,0,0,.117.321l.32.384A.568.568,0,0,0,.821-5a.581.581,0,0,0,.321-.116L2-5.822V0A1,1,0,0,0,3,1H7A1,1,0,0,0,8,0V-3.25h2V0a1,1,0,0,0,1,1h4a1,1,0,0,0,1-.992v-5.83l.86.707A.58.58,0,0,0,17.181-5a.568.568,0,0,0,.383-.179l.32-.384A.58.58,0,0,0,18-5.884a.567.567,0,0,0-.18-.384ZM14.5-.5h-3V-3.75a1,1,0,0,0-1-1h-3a1,1,0,0,0-1,1V-.5h-3V-7.054L9-11.573l5.5,4.517Z"
      transform="translate(1 16)"
      fill="currentColor"
    />
  ),
}))``;

export const JobIcon = styled(Icon).attrs(() => ({
  children: (
    <path
      d="M14.5-10H12v-1.5A1.5,1.5,0,0,0,10.5-13h-5A1.5,1.5,0,0,0,4-11.5V-10H1.5A1.5,1.5,0,0,0,0-8.5v8A1.5,1.5,0,0,0,1.5,1h13A1.5,1.5,0,0,0,16-.5v-8A1.5,1.5,0,0,0,14.5-10Zm-9-1.5h5V-10h-5Zm-3.812,3H14.312a.188.188,0,0,1,.188.188V-6H1.5V-8.312A.188.188,0,0,1,1.687-8.5Zm12.625,8H1.687A.188.188,0,0,1,1.5-.687V-4.5H6v.75A.75.75,0,0,0,6.75-3h2.5A.75.75,0,0,0,10-3.75V-4.5h4.5V-.687a.188.188,0,0,1-.188.187Z"
      transform="translate(2 15)"
      fill="currentColor"
    />
  ),
}))``;

export const LockIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 20 20',
  children: (
    <g>
      <g data-name="Group 16456">
        <path data-name="Path 2080" d="M0 0h20v20H0z" fill="none" />
        <path
          data-name="Path 2081"
          d="M0 0h20v20H0z"
          fill="none"
          opacity="0.87"
        />
      </g>
      <path
        data-name="Path 2082"
        d="M15.667 6.833h-.833V5.167a4.167 4.167 0 0 0-8.333 0v1.666h-.834A1.672 1.672 0 0 0 4 8.5v8.333A1.672 1.672 0 0 0 5.667 18.5h10a1.672 1.672 0 0 0 1.667-1.667V8.5a1.672 1.672 0 0 0-1.667-1.667zm-5 7.5a1.667 1.667 0 1 1 1.667-1.667 1.672 1.672 0 0 1-1.667 1.667zm-2.5-7.5V5.167a2.5 2.5 0 0 1 5 0v1.666z"
        transform="translate(-.667 -.167)"
        fill="currentColor"
      />
    </g>
  ),
}))``;

export const LockOutlineIcon = styled(Icon).attrs(() => ({
  children: (
    <path
      d="M12.5-8h-1V-9.456A4.528,4.528,0,0,0,7.012-14,4.506,4.506,0,0,0,2.5-9.5V-8h-1A1.5,1.5,0,0,0,0-6.5v7A1.5,1.5,0,0,0,1.5,2h11A1.5,1.5,0,0,0,14,.5v-7A1.5,1.5,0,0,0,12.5-8ZM4-9.5a3,3,0,0,1,3-3,3,3,0,0,1,3,3V-8H4ZM12.5.5H1.5v-7h11Z"
      transform="translate(3 15)"
      fill="currentColor"
    />
  ),
}))``;

export const UserIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 20 20',
  children: (
    <g>
      <path data-name="Path 2084" d="M0 0h20v20H0z" fill="none" />
      <path
        data-name="Path 2085"
        d="M10 10a3 3 0 1 0-3-3 3 3 0 0 0 3 3zm0 1.5c-2 0-6 1.005-6 3v.75a.752.752 0 0 0 .75.75h10.5a.752.752 0 0 0 .75-.75v-.75c0-1.995-4-3-6-3z"
        fill="currentColor"
      />
    </g>
  ),
}))``;

export const AddNewIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 25 25',
  children: (
    <path
      d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm4 11h-3v3a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8a1 1 0 1 1 2 0v3h3a1 1 0 1 1 0 2z"
      fill="currentColor"
    />
  ),
}))``;

export const AlertIcon = styled(Icon).attrs(() => ({
  children: (
    <path
      d="M8-13.75A7.751,7.751,0,0,0,.25-6,7.75,7.75,0,0,0,8,1.75,7.75,7.75,0,0,0,15.75-6,7.751,7.751,0,0,0,8-13.75Zm0,14A6.246,6.246,0,0,1,3.579-1.579,6.246,6.246,0,0,1,1.75-6,6.248,6.248,0,0,1,8-12.25,6.248,6.248,0,0,1,14.25-6a6.246,6.246,0,0,1-1.829,4.421A6.246,6.246,0,0,1,8,.25ZM9.312-3A1.314,1.314,0,0,0,8-4.312,1.314,1.314,0,0,0,6.687-3,1.314,1.314,0,0,0,8-1.687,1.314,1.314,0,0,0,9.312-3ZM6.77-9.606l.212,4.25A.375.375,0,0,0,7.357-5H8.643a.375.375,0,0,0,.375-.356l.212-4.25a.375.375,0,0,0-.1-.277A.375.375,0,0,0,8.856-10H7.144a.375.375,0,0,0-.271.117.375.375,0,0,0-.1.277Z"
      transform="translate(1.75 15.75)"
      fill="currentColor"
    />
  ),
}))``;

export const AlarmIcon = styled(Icon).attrs(() => ({
  children: (
    <path
      d="M12-8.25A2.251,2.251,0,0,0,9.75-10.5a2.252,2.252,0,0,0-1.9,1.041A6.02,6.02,0,0,1,11.28-6.6,2.238,2.238,0,0,0,12-8.25ZM4.148-9.459A2.252,2.252,0,0,0,2.25-10.5,2.251,2.251,0,0,0,0-8.25,2.238,2.238,0,0,0,.72-6.6,6.02,6.02,0,0,1,4.148-9.459ZM11.726,1.226a.939.939,0,0,0,0-1.327L10.6-1.223a5.224,5.224,0,0,0,.65-2.527A5.25,5.25,0,0,0,6-9,5.25,5.25,0,0,0,.75-3.75,5.224,5.224,0,0,0,1.4-1.223L.274-.1A.938.938,0,1,0,1.6,1.226L2.588.239A5.229,5.229,0,0,0,6,1.5,5.234,5.234,0,0,0,9.412.239l.987.987a.937.937,0,0,0,1.327,0ZM8.13-2.9a.282.282,0,0,1,.063.394l-.66.906a.283.283,0,0,1-.394.061L5.271-2.9a.28.28,0,0,1-.115-.227v-3.56a.282.282,0,0,1,.281-.281H6.562a.282.282,0,0,1,.281.281v2.845Z"
      transform="translate(4.02 14.5)"
      fill="currentColor"
    />
  ),
}))``;

export const FlagIcon = styled(Icon).attrs(() => ({
  children: (
    <path
      d="M8.32-8.185C7.044-8.185,5.99-9,4.386-9a4.693,4.693,0,0,0-1.62.282,1.544,1.544,0,0,0,.088-.469V-9.27A1.328,1.328,0,0,0,1.576-10.5a1.324,1.324,0,0,0-.975.36,1.324,1.324,0,0,0-.414.953A1.3,1.3,0,0,0,.759-8.111V.937A.567.567,0,0,0,1.33,1.5h.381A.567.567,0,0,0,2.283.937V-1.275a6.744,6.744,0,0,1,2.725-.518c1.276,0,2.33.815,3.934.815a5.037,5.037,0,0,0,2.917-.958.745.745,0,0,0,.33-.618v-5.7a.761.761,0,0,0-.356-.635.761.761,0,0,0-.727-.045,7.017,7.017,0,0,1-2.786.749Z"
      transform="translate(3.813 14.502)"
      fill="currentColor"
    />
  ),
}))``;

export const AddUserIcon = styled(Icon).attrs(() => ({
  children: (
    <path
      d="M17.062-6.562h-1.75v-1.75a.439.439,0,0,0-.437-.437H14a.439.439,0,0,0-.437.437v1.75h-1.75a.439.439,0,0,0-.437.437v.875a.439.439,0,0,0,.437.437h1.75v1.75A.439.439,0,0,0,14-2.625h.875a.439.439,0,0,0,.437-.437v-1.75h1.75A.439.439,0,0,0,17.5-5.25v-.875a.439.439,0,0,0-.438-.437ZM6.125-5.25a3.5,3.5,0,0,0,3.5-3.5,3.5,3.5,0,0,0-3.5-3.5,3.5,3.5,0,0,0-3.5,3.5A3.5,3.5,0,0,0,6.125-5.25Zm2.45.875H8.118a4.765,4.765,0,0,1-1.993.437,4.775,4.775,0,0,1-1.993-.437H3.675A3.676,3.676,0,0,0,0-.7V.437A1.313,1.313,0,0,0,1.312,1.75h9.625A1.313,1.313,0,0,0,12.25.437V-.7A3.676,3.676,0,0,0,8.575-4.375Z"
      transform="translate(2.5 14.75)"
      fill="currentColor"
    />
  ),
}))``;

export const PlusIcon = styled(Icon).attrs(() => ({
  children: (
    <path
      d="M13-5.874H8.5v-4.5a1,1,0,0,0-1-1h-1a1,1,0,0,0-1,1v4.5H1a1,1,0,0,0-.708.293A1,1,0,0,0,0-4.874v1a1,1,0,0,0,1,1H5.5v4.5a1,1,0,0,0,1,1h1a1,1,0,0,0,1-1v-4.5H13a1,1,0,0,0,1-1v-1a1,1,0,0,0-1-1Z"
      transform="translate(3 14.375)"
      fill="currentColor"
    />
  ),
}))``;

export const CirclePlusIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 24 24',
  children: (
    <g>
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        fill="currentColor"
        d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4z"
      />
    </g>
  ),
}))``;

export const CirclePlusBorderIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 12 12',
  children: (
    <g>
      <path data-name="Path 2011" d="M0 0h12v12H0z" fill="none" />
      <path
        d="M203.571 304v-3.571H200v-.857h3.571V296h.857v3.571H208v.857h-3.571V304z"
        transform="translate(-198 -294)"
        fill="currentColor"
      />
    </g>
  ),
}))``;

export const CancelIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 24 24',
  children: (
    <g>
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        fill="currentColor"
        d="M12 2a10 10 0 1 0 10 10A9.991 9.991 0 0 0 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z"
      />
    </g>
  ),
}))``;

export const SearchIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 20 20',
  children: (
    <g>
      <path fill="none" d="M0 0h20v20H0z" />
      <path
        fill="#3a3a3a"
        d="M12.567 11.42h-.6l-.214-.207a4.989 4.989 0 1 0-.536.536l.207.214v.6l3.253 3.253a.806.806 0 1 0 1.14-1.141zm-4.592 0a3.445 3.445 0 1 1 3.444-3.445 3.44 3.44 0 0 1-3.444 3.445z"
      />
    </g>
  ),
}))``;

export const UploadImageIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 30 30',
  children: (
    <g>
      <path fill="none" d="M0 0h30v30H0z" />
      <path
        fill="#22c759"
        d="M4.5 4.5h8.75V2H4.5A2.507 2.507 0 0 0 2 4.5v8.75h2.5zM12 15.75L7 22h15l-3.75-5-2.538 3.387zm8.75-5.625A1.875 1.875 0 1 0 18.875 12a1.872 1.872 0 0 0 1.875-1.875zM24.5 2h-8.75v2.5h8.75v8.75H27V4.5A2.507 2.507 0 0 0 24.5 2zm0 22.5h-8.75V27h8.75a2.507 2.507 0 0 0 2.5-2.5v-8.75h-2.5zm-20-8.75H2v8.75A2.507 2.507 0 0 0 4.5 27h8.75v-2.5H4.5z"
        transform="translate(.5 .5)"
      />
    </g>
  ),
}))``;

export const UploadImage = styled(Icon).attrs(() => ({
  children: (
    <path
      d="M72.763 224.186c0 21.653 17.556 39.27 39.135 39.27s39.135-17.616 39.135-39.27-17.556-39.271-39.135-39.271c-21.579-.001-39.135 17.616-39.135 39.271zM39.135-24.272c13.308 0 24.135 10.888 24.135 24.271 0 13.382-10.827 24.27-24.135 24.27s-24.135-10.888-24.135-24.27c0-13.383 10.827-24.271 24.135-24.271zM487.944 95.93c-2.803-3.05-7.546-3.253-10.597-.45-3.051 2.802-3.253 7.546-.451 10.597 12.964 14.114 20.104 32.474 20.104 51.694 0 42.05-34.05 76.26-75.904 76.26-41.852 0-75.902-34.21-75.902-76.26s34.05-76.26 75.902-76.26c10.399 0 20.47 2.071 29.935 6.157 3.803 1.64 8.217-.109 9.858-3.913 1.642-3.803-.11-8.217-3.913-9.858-11.353-4.9-23.424-7.386-35.88-7.386-35.864 0-66.94 20.961-81.721 51.319h-325.911c-7.424.001-13.464 6.053-13.464 13.491v300.677c0 7.439 6.04 13.49 13.464 13.49h456.854c7.424 0 13.464-6.052 13.464-13.49v-104.998c0-4.143-3.358-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v103.488h-453.782v-297.657h318.644c-1.369 4.832-2.345 9.828-2.903 14.948h-208.741c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h208.332c2.599 48.001 42.314 86.252 90.764 86.252 6.114 0 12.087-.613 17.866-1.774v107.009l-44.017-62.822c-2.323-3.314-5.813-5.216-9.575-5.216-3.761.001-7.251 1.902-9.574 5.217l-43.03 61.415-80.673-115.141c-2.323-3.314-5.813-5.215-9.574-5.215-3.762 0-7.251 1.9-9.575 5.216l-80.89 115.451-43.249-61.728c-2.323-3.314-5.813-5.215-9.575-5.215-3.761.001-7.25 1.901-9.574 5.217l-44.835 63.991v-192.657h42.178c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5h-43.714c-7.424 0-13.464 6.052-13.464 13.49v240.78c0 7.439 6.04 13.49 13.464 13.49h397.212c7.424 0 13.464-6.052 13.464-13.49v-159.192c5.188-2.027 10.144-4.52 14.821-7.424v55.567c0 4.143 3.358 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-67.197c17.376-16.631 28.218-40.084 28.218-66.032 0-22.989-8.543-44.951-24.056-61.841zM-443.123 304.61v-18.963l54.41-77.658 67.696 96.621zM140.423 0-24.031-34.299 81.307-116.046 105.338 150.345zM253.717 0h-72.788l-24.25-34.61 43.447-62.01 53.59 76.487v20.133zM421.096 100.275c-3.271 0-6.397 1.399-8.577 3.84l-32.318 36.181c-3.013 3.377-3.766 8.228-1.917 12.357 1.851 4.132 5.97 6.802 10.497 6.802h11.315v46.316c0 6.341 5.159 11.5 11.5 11.5h19c6.341 0 11.5-5.159 11.5-11.5v-46.316h11.315c4.526 0 8.647-2.67 10.497-6.803 1.849-4.129 1.096-8.979-1.92-12.359l-32.315-36.178c-2.179-2.44-5.306-3.84-8.577-3.84zM13.5 44.18c-4.142 0-7.5 3.357-7.5 7.5v50.316h-12v-50.316c0-4.143-3.358-7.5-7.5-7.5h-10.998l24.498-27.426 24.498 27.426z"
      fill="currentColor"
    />
  ),
}))``;

export const CheckIcon = styled(Icon).attrs(() => ({
  children: (
    <path
      d="M-8949.75-17422.059l3.785,3.785,10.215-10.213"
      transform="translate(8952.75 17432.99)"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
  ),
}))``;

export const ArrowUpIcon = styled(Icon).attrs(() => ({
  children: (
    <path
      d="M-16458.459-17671.709l-8,8,8,8"
      transform="translate(-17653.709 16472.957) rotate(90)"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
  ),
}))``;

export const EditIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 16 16',
  children: (
    <g>
      <path data-name="Path 2011" d="M0 0h16v16H0z" fill="none" />
      <path
        data-name="Path 2012"
        d="M3 12.5V15h2.5l7.373-7.373-2.5-2.5zm11.807-6.807a.664.664 0 0 0 0-.94l-1.56-1.56a.664.664 0 0 0-.94 0l-1.22 1.22 2.5 2.5z"
        transform="translate(-1 -.999)"
        fill="currentColor"
      />
    </g>
  ),
}))``;

export const WorkIcon = styled(Icon).attrs(() => ({
  children: (
    <path
      d="M10-1.875a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-1.5H0v4.5a1.538,1.538,0,0,0,1.5,1.5h13a1.538,1.538,0,0,0,1.5-1.5v-4.5H10Zm4.5-6.5H12v-1.5a1.538,1.538,0,0,0-1.5-1.5h-5A1.538,1.538,0,0,0,4-9.875v1.5H1.5A1.538,1.538,0,0,0,0-6.875v2.5H16v-2.5A1.538,1.538,0,0,0,14.5-8.375Zm-4.5,0H6v-1h4Z"
      transform="translate(2 13.874)"
      fill="currentColor"
    />
  ),
}))``;

export const SubtaskIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 28 28',
  children: (
    <g id="Subtask">
      <rect
        width="15"
        height="2"
        rx="1"
        transform="translate(9.004 7)"
        fill="#999"
      />
      <rect
        width="9"
        height="2"
        rx="1"
        transform="translate(9.004 13)"
        fill="#999"
      />
      <rect
        width="13"
        height="2"
        rx="1"
        transform="translate(9.004 19)"
        fill="#999"
      />
      <path
        d="M.142-4.46H2.627v-1H2.094v-3h-1L-.1-8.137l.238.982L.789-7.3v1.84H.142Z"
        transform="translate(4.1 14.461)"
        fill="#999"
      />
      <path
        d="M.2,11.444H3.51V10.417H1.976l.7-.449A1.382,1.382,0,0,0,3.468,8.74V8.729A1.381,1.381,0,0,0,1.926,7.444a2,2,0,0,0-1.734.864l.864.735c.325-.348.533-.488.757-.488s.353.123.353.292c0,.151-.1.3-.342.477L.2,10.49Z"
        transform="translate(3.813 4.557)"
        fill="#999"
      />
      <path
        d="M1.783,27.6c.867,0,1.606-.47,1.606-1.315v-.011a1.114,1.114,0,0,0-.968-1.113L3.3,24.5v-.9H.289v1.018H1.744L.882,25.3l.173.582H1.61c.347,0,.515.123.515.313v.011c0,.185-.157.313-.448.313A1.354,1.354,0,0,1,.754,26.1l-.778.8a2.38,2.38,0,0,0,1.807.7Z"
        transform="translate(4.027 -5.6)"
        fill="#999"
      />
    </g>
  ),
}))``;

export const SettingIcon = styled(Icon).attrs(() => ({
  children: (
    <path
      d="M16.374-3.824,14.94-4.618a5.954,5.954,0,0,0,0-2.265l1.435-.794a.383.383,0,0,0,.185-.452,7.961,7.961,0,0,0-1.843-3.051.419.419,0,0,0-.5-.074l-1.433.794a6.431,6.431,0,0,0-2.049-1.132v-1.584a.391.391,0,0,0-.317-.378,8.836,8.836,0,0,0-3.676,0,.391.391,0,0,0-.317.378v1.587a6.635,6.635,0,0,0-2.05,1.132L2.943-11.25a.413.413,0,0,0-.5.074A7.912,7.912,0,0,0,.6-8.122a.379.379,0,0,0,.185.452l1.435.791a5.954,5.954,0,0,0,0,2.265L.787-3.821A.383.383,0,0,0,.6-3.369,7.961,7.961,0,0,0,2.444-.317a.419.419,0,0,0,.5.074L4.38-1.037A6.432,6.432,0,0,0,6.428.1V1.683a.391.391,0,0,0,.317.378,8.833,8.833,0,0,0,3.676,0,.391.391,0,0,0,.317-.378V.1a6.635,6.635,0,0,0,2.049-1.132l1.435.794a.413.413,0,0,0,.5-.074,7.913,7.913,0,0,0,1.843-3.052.391.391,0,0,0-.192-.455Zm-7.8.655A2.643,2.643,0,0,1,5.884-5.75a2.64,2.64,0,0,1,2.7-2.581,2.64,2.64,0,0,1,2.7,2.581,2.643,2.643,0,0,1-2.7,2.581Z"
      transform="translate(1.418 15.746)"
      fill="currentColor"
    />
  ),
}))``;

export const TrashIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 21 21',
  children: (
    <path
      fill="currentColor"
      d="M6 19a2.006 2.006 0 0 0 2 2h8a2.006 2.006 0 0 0 2-2V9a2.006 2.006 0 0 0-2-2H8a2.006 2.006 0 0 0-2 2zM18 4h-2.5l-.71-.71a1.009 1.009 0 0 0-.7-.29H9.91a1.009 1.009 0 0 0-.7.29L8.5 4H6a1 1 0 1 0 0 2h12a1 1 0 0 0 0-2z"
      transform="translate(-1 -0.5)"
    />
  ),
}))``;

export const EllipseVerticalIcon = styled(Icon).attrs(() => ({
  children: (
    <g>
      <circle
        cx="2"
        cy="2"
        r="2"
        transform="translate(8 2)"
        fill="currentColor"
      />
      <circle
        cx="2"
        cy="2"
        r="2"
        transform="translate(8 14)"
        fill="currentColor"
      />
      <circle
        cx="2"
        cy="2"
        r="2"
        transform="translate(8 8)"
        fill="currentColor"
      />
    </g>
  ),
}))``;

export const CloseIcon = styled(Icon).attrs(() => ({
  children: (
    <path
      d="M9.654,87l3.98-3.98a1.251,1.251,0,0,0,0-1.769l-.885-.885a1.251,1.251,0,0,0-1.769,0L7,84.346l-3.98-3.98a1.251,1.251,0,0,0-1.769,0l-.885.885a1.251,1.251,0,0,0,0,1.769L4.346,87,.366,90.98a1.251,1.251,0,0,0,0,1.769l.885.885a1.251,1.251,0,0,0,1.769,0L7,89.654l3.98,3.98a1.251,1.251,0,0,0,1.769,0l.885-.885a1.251,1.251,0,0,0,0-1.769Z"
      transform="translate(3 -77)"
      fill="currentColor"
    />
  ),
}))``;

export const NotificationIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 26.25 30',
  children: (
    <path
      d="M13.125 17.75A3.749 3.749 0 0 0 16.873 14h-7.5a3.749 3.749 0 0 0 3.752 3.75zm12.62-8.772C24.613 7.762 22.5 5.932 22.5-.062A9.253 9.253 0 0 0 15-9.154v-1.221a1.875 1.875 0 0 0-1.874-1.875 1.875 1.875 0 0 0-1.874 1.875v1.221a9.253 9.253 0 0 0-7.5 9.091c0 5.994-2.118 7.824-3.25 9.04A1.831 1.831 0 0 0 0 10.25a1.877 1.877 0 0 0 1.881 1.875h22.488a1.876 1.876 0 0 0 1.881-1.875 1.83 1.83 0 0 0-.505-1.272z"
      transform="translate(0 12.25)"
      fill="currentColor"
    />
  ),
}))``;

export const ArchiveIcon = styled(Icon).attrs(() => ({
  children: (
    <path
      d="M1,45a1,1,0,0,0,1,1H14a1,1,0,0,0,1-1V36H1Zm5-6.625A.376.376,0,0,1,6.375,38h3.25a.376.376,0,0,1,.375.375v.25A.376.376,0,0,1,9.625,39H6.375A.376.376,0,0,1,6,38.625ZM15,32H1a1,1,0,0,0-1,1v1.5a.5.5,0,0,0,.5.5h15a.5.5,0,0,0,.5-.5V33A1,1,0,0,0,15,32Z"
      transform="translate(2 -29)"
      fill="currentColor"
    />
  ),
}))``;

export const SignOutIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 20 20',
  children: (
    <g>
      <g data-name="Group 16457">
        <path data-name="Rectangle 5718" fill="none" d="M0 0h20v20H0z" />
        <path data-name="Rectangle 5719" fill="none" d="M0 0h20v20H0z" />
      </g>
      <g data-name="Group 16458">
        <path
          data-name="Path 2083"
          d="M8.917 6.917a.82.82 0 0 0 0 1.167L10.5 9.667H2.833A.836.836 0 0 0 2 10.5a.836.836 0 0 0 .833.833H10.5l-1.583 1.584a.82.82 0 0 0 0 1.167.82.82 0 0 0 1.167 0l2.992-2.992a.83.83 0 0 0 0-1.175l-2.992-3a.82.82 0 0 0-1.167 0zM17 16.333h-5.833a.836.836 0 0 0-.833.833.836.836 0 0 0 .833.833H17a1.672 1.672 0 0 0 1.667-1.667V4.667A1.672 1.672 0 0 0 17 3h-5.833a.836.836 0 0 0-.833.833.836.836 0 0 0 .833.833H17z"
          transform="translate(-.333 -.5)"
          fill="currentColor"
        />
      </g>
    </g>
  ),
}))``;

export const ImageIcon = styled(Icon).attrs(() => ({
  children: (
    <path
      d="M14.5-12H1.5A1.5,1.5,0,0,0,0-10.5v9A1.5,1.5,0,0,0,1.5,0h13A1.5,1.5,0,0,0,16-1.5v-9A1.5,1.5,0,0,0,14.5-12ZM15-1.5a.5.5,0,0,1-.5.5H1.5A.5.5,0,0,1,1-1.5v-9a.5.5,0,0,1,.5-.5h13a.5.5,0,0,1,.5.5ZM3.5-6.75A1.75,1.75,0,0,0,5.25-8.5,1.75,1.75,0,0,0,3.5-10.25,1.75,1.75,0,0,0,1.75-8.5,1.75,1.75,0,0,0,3.5-6.75Zm0-2.5a.75.75,0,0,1,.752.75.75.75,0,0,1-.75.748.75.75,0,0,1-.75-.748A.751.751,0,0,1,3.5-9.25Zm6.47.72L7-5.561,6.03-6.53a.75.75,0,0,0-1.061,0L2.22-3.78A.861.861,0,0,0,2-3.25v.875A.375.375,0,0,0,2.375-2H13.623A.375.375,0,0,0,14-2.375V-5.25a.75.75,0,0,0-.218-.532L11.03-8.531A.75.75,0,0,0,9.97-8.531ZM13-3H3v-.146l2.5-2.5L7-4.145l3.5-3.5,2.5,2.5Z"
      transform="translate(2 16)"
      fill="currentColor"
    />
  ),
}))``;

export const FileIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 28 28',
  children: (
    <path
      d="M21,5H11.72l-.32-1A3,3,0,0,0,8.56,2H3A3,3,0,0,0,0,5V19a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V8A3,3,0,0,0,21,5Zm1,14a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V5A1,1,0,0,1,3,4H8.56a1,1,0,0,1,.95.68L10.28,7H21a1,1,0,0,1,1,1ZM12.71,9.29a1,1,0,0,0-.33-.21,1,1,0,0,0-.76,0,1,1,0,0,0-.33.21l-3,3a1,1,0,0,0,1.42,1.42L11,12.41V18a1,1,0,0,0,2,0V12.41l1.29,1.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z"
      fill="currentColor"
    />
  ),
}))``;

export const SendIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 512 512',
  children: (
    <path
      fill="currentColor"
      d="M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"
    />
  ),
}))``;

export const HourglassIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 9 12',
  children: (
    <path
      fill="currentColor"
      d="M3.937-10.5h-7.875a.562.562 0 0 0-.562.562v.375A.562.562 0 0 0-3.938-9a4.651 4.651 0 0 0 2.833 4.5A4.651 4.651 0 0 0-3.938 0 .562.562 0 0 0-4.5.562v.375a.562.562 0 0 0 .562.562h7.875A.562.562 0 0 0 4.5.937V.562A.562.562 0 0 0 3.937 0a4.651 4.651 0 0 0-2.832-4.5A4.651 4.651 0 0 0 3.937-9a.562.562 0 0 0 .563-.562v-.375a.562.562 0 0 0-.563-.563zm-1.76 9h-4.355A2.517 2.517 0 0 1 0-3.375 2.517 2.517 0 0 1 2.178-1.5zm0-6h-4.355a4.4 4.4 0 0 1-.26-1.5h4.875a4.4 4.4 0 0 1-.259 1.5z"
      transform="translate(4.5 10.5)"
    />
  ),
}))``;

export const PlayIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 16 16',
  children: (
    <path
      fill="currentColor"
      d="M8.281-15.469a8 8 0 0 0-8 8 8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8zM11.1-6.695L7.254-4.354A.776.776 0 0 1 6.1-5.031v-4.875a.776.776 0 0 1 1.152-.677L11.1-8.049a.777.777 0 0 1 0 1.354z"
      transform="translate(-.281 15.469)"
    />
  ),
}))``;

export const PauseIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 16 16',
  children: (
    <path
      fill="currentColor"
      d="M8.187-10.312a8 8 0 0 0-8 8 8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8zM7.671.268a.518.518 0 0 1-.516.516H5.607a.518.518 0 0 1-.516-.516v-5.161a.518.518 0 0 1 .516-.516h1.548a.518.518 0 0 1 .516.516zm3.613 0a.518.518 0 0 1-.516.516H9.22A.518.518 0 0 1 8.7.268v-5.161a.518.518 0 0 1 .516-.516h1.548a.518.518 0 0 1 .516.516z"
      transform="translate(-.188 10.312)"
    />
  ),
}))``;

export const LinkIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 512 512',
  children: (
    <path
      fill="currentColor"
      d="M14.442 7h-2.489a.853.853 0 0 0 0 1.706h2.488a2.559 2.559 0 0 1 0 5.117h-2.488a.853.853 0 0 0 0 1.706h2.488a4.265 4.265 0 0 0 0-8.528zm-7.465 4.264a.844.844 0 0 0 .829.853h4.977a.853.853 0 0 0 0-1.706H7.806a.844.844 0 0 0-.829.853zm1.659 2.558H6.147a2.559 2.559 0 0 1 0-5.117h2.489a.853.853 0 0 0 0-1.705H6.147a4.265 4.265 0 0 0 0 8.528h2.489a.853.853 0 0 0 0-1.706z"
      transform="translate(-.294 -1.264)"
    />
  ),
}))``;

export const LinkHorizontalIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 20 20',
  children: (
    <path
      fill="currentColor"
      d="M14.442 7h-2.489a.853.853 0 0 0 0 1.706h2.488a2.559 2.559 0 0 1 0 5.117h-2.488a.853.853 0 0 0 0 1.706h2.488a4.265 4.265 0 0 0 0-8.528zm-7.465 4.264a.844.844 0 0 0 .829.853h4.977a.853.853 0 0 0 0-1.706H7.806a.844.844 0 0 0-.829.853zm1.659 2.558H6.147a2.559 2.559 0 0 1 0-5.117h2.489a.853.853 0 0 0 0-1.705H6.147a4.265 4.265 0 0 0 0 8.528h2.489a.853.853 0 0 0 0-1.706z"
      transform="translate(-.294 -1.264)"
    />
  ),
}))``;

export const CloneIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 512 512',
  children: (
    <path
      fill="currentColor"
      d="M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z"
    />
  ),
}))``;

export const DuplicateIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 20 20',
  children: (
    <path
      fill="currentColor"
      d="M12.767 1H3.656A1.665 1.665 0 0 0 2 2.663v10.81a.828.828 0 1 0 1.656 0V3.495a.832.832 0 0 1 .828-.832h8.282a.832.832 0 0 0 0-1.663zm.489 3.817l4 4.016a1.665 1.665 0 0 1 .48 1.173v7.625a1.665 1.665 0 0 1-1.656 1.663H6.961a1.658 1.658 0 0 1-1.648-1.663l.008-11.642a1.658 1.658 0 0 1 1.648-1.663h5.11a1.658 1.658 0 0 1 1.177.491zm-.489 5.33h3.727l-4.555-4.573v3.742a.832.832 0 0 0 .828.831z"
      transform="translate(-.294 -.147)"
    />
  ),
}))``;

export const KanBanIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 13 14',
  children: (
    <g transform="translate(-1122 -61.5)">
      <path
        d="M7.421 7.368h3.158V14.2H7.421zm4.421 6.832h1.895A1.258 1.258 0 0 0 15 12.956v-5.6h-3.158zM13.737 3H4.263A1.258 1.258 0 0 0 3 4.244v1.867h12V4.244A1.258 1.258 0 0 0 13.737 3zM3 12.956A1.258 1.258 0 0 0 4.263 14.2h1.895V7.356H3z"
        transform="translate(1119 61)"
        fill="currentColor"
      />
      <g>
        <path d="M0 0h20v20H0z" fill="none" />
      </g>
    </g>
  ),
}))``;

export const GridIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 16 14',
  children: (
    <path
      fill="currentColor"
      d="M0-14.75v11a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5v-11a1.5 1.5 0 0 0-1.5-1.5h-13a1.5 1.5 0 0 0-1.5 1.5zm15 0v2.833H6v-3.333h8.5a.5.5 0 0 1 .5.5zm0 7.167H6v-3.333h9zM1-10.917h4v3.333H1zm4-4.333v3.333H1v-2.833a.5.5 0 0 1 .5-.5zM1-3.75v-2.833h4v3.333H1.5a.5.5 0 0 1-.5-.5zm5 .5v-3.333h9v2.833a.5.5 0 0 1-.5.5z"
      transform="translate(0 16.25)"
    />
  ),
}))``;

export const CalendarIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 13 14',
  children: (
    <g transform="translate(-1122 -61)">
      <path fill="none" d="M0 0h20v20H0z" transform="translate(1118 59)" />
      <path
        fill="currentColor"
        d="M13.742 3.343h-.671v-.672a.671.671 0 1 0-1.343 0v.671H6.357v-.671a.671.671 0 1 0-1.343 0v.671h-.671a1.337 1.337 0 0 0-1.336 1.344L3 14.085a1.342 1.342 0 0 0 1.343 1.343h9.4a1.347 1.347 0 0 0 1.343-1.343v-9.4a1.347 1.347 0 0 0-1.344-1.342zm0 10.071a.673.673 0 0 1-.671.671H5.014a.673.673 0 0 1-.671-.671V6.7h9.4z"
        transform="translate(1119 60)"
      />
      <rect
        fill="currentColor"
        width="3"
        height="3"
        rx="1"
        transform="translate(1124 68)"
      />
      <rect
        fill="currentColor"
        width="3"
        height="3"
        rx="1"
        transform="translate(1128 68)"
      />
    </g>
  ),
}))``;

export const StarIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 576 512',
  children: (
    <path
      fill="currentColor"
      d="M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"
    />
  ),
}))``;

export const StarFilledIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 576 512',
  children: (
    <path
      fill="currentColor"
      d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
    />
  ),
}))``;

export const PaperClipIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 512 512',
  children: (
    <path
      fill="currentColor"
      d="M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"
    />
  ),
}))``;

export const FilterIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 512 512',
  children: (
    <path
      fill="currentColor"
      d="M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"
    />
  ),
}))``;

export const ListIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 11 14',
  children: (
    <g transform="translate(-1122 -63)">
      <path
        fill="currentColor"
        d="M3.765 11.429h1.529a.743.743 0 0 0 .765-.714V9.286a.743.743 0 0 0-.765-.714H3.765A.743.743 0 0 0 3 9.286v1.429a.743.743 0 0 0 .765.714zm0 3.571h1.529a.743.743 0 0 0 .765-.714v-1.429a.743.743 0 0 0-.765-.714H3.765a.743.743 0 0 0-.765.714v1.429a.743.743 0 0 0 .765.714zm0-7.143h1.529a.743.743 0 0 0 .765-.714V5.714A.743.743 0 0 0 5.294 5H3.765A.743.743 0 0 0 3 5.714v1.429a.743.743 0 0 0 .765.714zm3.824 3.571h7.647a.743.743 0 0 0 .764-.714V9.286a.743.743 0 0 0-.765-.714H7.588a.743.743 0 0 0-.765.714v1.429a.743.743 0 0 0 .765.714zm0 3.571h7.647a.743.743 0 0 0 .764-.713v-1.429a.743.743 0 0 0-.765-.714H7.588a.743.743 0 0 0-.765.714v1.429a.743.743 0 0 0 .765.714zm-.765-9.285v1.429a.743.743 0 0 0 .765.714h7.647A.743.743 0 0 0 16 7.143V5.714A.743.743 0 0 0 15.235 5H7.588a.743.743 0 0 0-.764.714z"
        transform="translate(1119 61)"
      />
    </g>
  ),
}))``;

export const AddNewCompanyIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 20 20',
  children: (
    <>
      <path
        id="Subtraction_1"
        d="M10 15H0V0h8.333v3.333h8.333v8.333h-.833v-2.5H15V5H8.333v1.667H10v1.666H8.333V10H10v1.667H8.333v1.667H10V15zm-5-3.333v1.667h1.667v-1.667zm-3.334 0v1.667h1.667v-1.667zM5 8.333V10h1.667V8.333zm-3.334 0V10h1.667V8.333zM5 5v1.667h1.667V5zM1.666 5v1.667h1.667V5zM5 1.667v1.666h1.667V1.667zm-3.334 0v1.666h1.667V1.667zm10.833 10h-.833V10h.834v1.666zm.834-3.333h-1.666V6.667h1.667v1.665z"
        className="cls-2"
        transform="translate(1.666 2.5)"
        fill="currentColor"
      />
      <path
        id="Path_2002"
        d="M19.167 17.5V15H17.5v2.5H15v1.667h2.5v2.5h1.667v-2.5h2.5V17.5z"
        className="cls-2"
        transform="translate(-2.5 -2.5)"
        fill="currentColor"
      />
    </>
  ),
}))``;

export const ChevronLeft = styled(Icon).attrs(() => ({
  viewBox: '0 0 20 20',
  children: (
    <>
      <path
        fill="currentColor"
        d="M11.29 8.71L6.7 13.3a1 1 0 0 0 1.41 1.41L12 10.83l3.88 3.88a1 1 0 1 0 1.41-1.41L12.7 8.71a1 1 0 0 0-1.41 0z"
        transform="rotate(-90 12 12)"
      />
    </>
  ),
}))``;

export const Board = styled(Icon).attrs(() => ({
  viewBox: '0 0 20 20',
  children: (
    <g id="Group_16958" data-name="Group 16958" transform="translate(-78 -777)">
      <path
        id="Path_2128"
        data-name="Path 2128"
        d="M8.526,8.46h3.947V17H8.526ZM14.053,17h2.368A1.572,1.572,0,0,0,18,15.444v-7H14.053ZM16.421,3H4.579A1.572,1.572,0,0,0,3,4.556V6.889H18V4.556A1.572,1.572,0,0,0,16.421,3ZM3,15.444A1.572,1.572,0,0,0,4.579,17H6.947V8.444H3Z"
        transform="translate(77.5 777.333)"
        fill="currentColor"
      />
      <path
        id="Path_2003"
        data-name="Path 2003"
        d="M0,0H20V20H0Z"
        transform="translate(78 777)"
        fill="none"
      />
    </g>
  ),
}))``;

export const MagnifyingGlass = styled(Icon).attrs(() => ({
  viewBox: '0 0 20 20',
  children: (
    <g
      id="Group_16963"
      data-name="Group 16963"
      transform="translate(-181 -713)"
    >
      <path
        id="Path_2033"
        data-name="Path 2033"
        d="M0,0H20V20H0Z"
        transform="translate(181 713)"
        fill="none"
      />
      <path
        id="Path_2034"
        data-name="Path 2034"
        d="M15.034,13.59h-.761L14,13.33A6.275,6.275,0,1,0,13.33,14l.26.27v.761l4.091,4.091a1.014,1.014,0,1,0,1.434-1.434Zm-5.776,0A4.332,4.332,0,1,1,13.59,9.257,4.326,4.326,0,0,1,9.257,13.59Z"
        transform="translate(180.085 712.085)"
        fill="currentColor"
      />
    </g>
  ),
}))``;

export const Pencil = styled(Icon).attrs(() => ({
  viewBox: '0 0 8 8',
  children: (
    <path
      fill="currentColor"
      d="M4.543-7.293L.2-2.951 0-1.167a.375.375 0 0 0 .414.414L2.2-.949l4.343-4.344zm3.237-.3l-.939-.937a.75.75 0 0 0-1.061 0l-.88.883 2 2 .88-.883a.75.75 0 0 0 0-1.061z"
      transform="translate(0 8.75)"
    />
  ),
}))``;

export const ExclamationIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 16 16',
  children: (
    <g>
      <path data-name="Path 2031" d="M0 0h16v16H0z" fill="none" />
      <path
        d="M8.4 2a6.4 6.4 0 1 0 6.4 6.4A6.4 6.4 0 0 0 8.4 2zm0 7.04a.642.642 0 0 1-.64-.64V5.84a.64.64 0 1 1 1.28 0V8.4a.642.642 0 0 1-.64.64zm.64 2.56H7.76v-1.28h1.28z"
        transform="translate(-.4 -.4)"
        fill="currentColor"
      />
    </g>
  ),
}))``;

export const PreviewIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 52 52',
  children: (
    <g>
      <path
        fill="currentColor"
        d="M51.8,25.1C47.1,15.6,37.3,9,26,9S4.9,15.6,0.2,25.1c-0.3,0.6-0.3,1.3,0,1.8C4.9,36.4,14.7,43,26,43
        s21.1-6.6,25.8-16.1C52.1,26.3,52.1,25.7,51.8,25.1z M26,37c-6.1,0-11-4.9-11-11s4.9-11,11-11s11,4.9,11,11S32.1,37,26,37z"
      />
      <path
        fill="currentColor"
        d="M26,19c-3.9,0-7,3.1-7,7s3.1,7,7,7s7-3.1,7-7S29.9,19,26,19z"
      />
    </g>
  ),
}))``;

export const DownloadIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 512 512',
  children: (
    <g>
      <path
        fill="currentColor"
        d="M480.6,341.4c-11.3,0-20.4,9.1-20.4,20.4v98.4H51.8v-98.4c0-11.3-9.1-20.4-20.4-20.4c-11.3,0-20.4,9.1-20.4,20.4v118.8    c0,11.3,9.1,20.4,20.4,20.4h449.2c11.3,0,20.4-9.1,20.4-20.4V361.8C501,350.5,491.9,341.4,480.6,341.4z"
      />
      <path
        fill="currentColor"
        d="m241,365.6c11.5,11.6 25.6,5.2 29.9,0l117.3-126.2c7.7-8.3 7.2-21.2-1.1-28.9-8.3-7.7-21.2-7.2-28.8,1.1l-81.9,88.1v-265.2c0-11.3-9.1-20.4-20.4-20.4-11.3,0-20.4,9.1-20.4,20.4v265.3l-81.9-88.1c-7.7-8.3-20.6-8.7-28.9-1.1-8.3,7.7-8.7,20.6-1.1,28.9l117.3,126.1z"
      />
    </g>
  ),
}))``;

export const CorrectIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 200 200',
  children: (
    <g>
      <path
        fill="currentColor"
        d="M100,15a85,85,0,1,0,85,85A84.93,84.93,0,0,0,100,15Zm0,150a65,65,0,1,1,65-65A64.87,64.87,0,0,1,100,165Zm25-91.5-29,35L76,94c-4.5-3.5-10.5-2.5-14,2s-2.5,10.5,2,14c6,4.5,12.5,9,18.5,13.5,4.5,3,8.5,7.5,14,8,1.5,0,3.5,0,5-1l3-3,22.5-27c4-5,8-9.5,12-14.5,3-4,4-9,.5-13L138,71.5c-3.5-2.5-9.5-2-13,2Z"
      />
    </g>
  ),
}))``;

export const FolderIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 60 60',
  children: (
    <g>
      <path
        fill="currentColor"
        d="M26.515,10.5l-5-7H0v53h60v-37v-2v-7H26.515z M31.515,17.5l-3.571-5H58v5H31.515z"
      />
    </g>
  ),
}))``;

export const UserCircleIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 20 20',
  children: (
    <g>
      <path data-name="Path 3043" d="M0 0h20v20H0z" fill="none" />
      <path
        data-name="Path 3044"
        d="M10.333 2a8.333 8.333 0 1 0 8.333 8.333A8.336 8.336 0 0 0 10.333 2zm3.008 5.283a1.608 1.608 0 1 1-1.608 1.608 1.6 1.6 0 0 1 1.608-1.608zm-5-1.317a1.967 1.967 0 1 1-1.966 1.967 1.97 1.97 0 0 1 1.967-1.966zm0 7.608V16.7a6.672 6.672 0 0 1-4.283-4.133c.875-.933 3.058-1.408 4.283-1.408a8.477 8.477 0 0 1 1.583.183 2.518 2.518 0 0 0-1.582 2.233zM10.333 17a5.709 5.709 0 0 1-.658-.033v-3.392c0-1.183 2.45-1.775 3.667-1.775a5.908 5.908 0 0 1 3.2.958A6.682 6.682 0 0 1 10.333 17z"
        transform="translate(-.333 -.333)"
        fill="currentColor"
      />
    </g>
  ),
}))``;

export const DatepickerIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 16 16',
  children: (
    <g>
      <path data-name="Path 2112" d="M0 0h16v16H0z" fill="none" />
      <path
        data-name="Path 2113"
        d="M12.667 2H12v-.666a.667.667 0 1 0-1.333 0v.667H5.333v-.667a.667.667 0 1 0-1.333 0v.667h-.667a1.327 1.327 0 0 0-1.326 1.333L2 12.667A1.333 1.333 0 0 0 3.333 14h9.333A1.337 1.337 0 0 0 14 12.667V3.334A1.337 1.337 0 0 0 12.667 2zM12 12.667H4A.669.669 0 0 1 3.333 12V5.334h9.333v6.667a.669.669 0 0 1-.666.666zm-6.667-6h2A.669.669 0 0 1 8 7.334v2a.669.669 0 0 1-.667.667h-2a.669.669 0 0 1-.667-.667v-2a.669.669 0 0 1 .667-.667z"
      />
    </g>
  ),
}))``;

export const SaveIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 20 20',
  children: (
    <g>
      <path data-name="Path 3011" d="M0 0h20v20H0z" fill="none" />
      <path
        data-name="Path 3012"
        d="M15.158 3.492A1.672 1.672 0 0 0 13.975 3H4.667A1.666 1.666 0 0 0 3 4.667v11.666A1.672 1.672 0 0 0 4.667 18h11.666A1.672 1.672 0 0 0 18 16.333V7.025a1.638 1.638 0 0 0-.492-1.175zM10.5 16.333a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5zM11.333 8h-5a1.667 1.667 0 1 1 0-3.333h5a1.667 1.667 0 0 1 0 3.333z"
        transform="translate(-.5 -.5)"
        fill="currentColor"
      />
    </g>
  ),
}))``;

export const EyeIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 24 24',
  children: (
    <g>
      <path data-name="Path 3026" d="M0 0h24v24H0z" fill="none" />
      <path
        data-name="Path 3027"
        d="M12 4a11.827 11.827 0 0 0-11 7.5 11.817 11.817 0 0 0 22 0A11.827 11.827 0 0 0 12 4zm0 12.5a5 5 0 1 1 5-5 5 5 0 0 1-5 5zm0-8a3 3 0 1 0 3 3 3 3 0 0 0-3-3z"
        fill="currentColor"
      />
    </g>
  ),
}))``;

export const EyeOffIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 24 24',
  children: (
    <g>
      <path
        data-name="Path 3058"
        d="M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z"
        fill="none"
      />
      <path
        data-name="Path 3059"
        d="M12 6.5a4.938 4.938 0 0 1 4.76 6.46l3.06 3.06A11.8 11.8 0 0 0 23 11.49 11.838 11.838 0 0 0 8.36 4.57l2.17 2.17A5.14 5.14 0 0 1 12 6.5zM2.71 3.16a1 1 0 0 0 0 1.41l1.97 1.97A11.892 11.892 0 0 0 1 11.5a11.8 11.8 0 0 0 15.31 6.68l2.72 2.72a1 1 0 1 0 1.41-1.41L4.13 3.16a1.008 1.008 0 0 0-1.42 0zM12 16.5a5 5 0 0 1-5-5 4.911 4.911 0 0 1 .49-2.14l1.57 1.57a3.434 3.434 0 0 0-.06.57 3 3 0 0 0 3 3 2.694 2.694 0 0 0 .57-.07L14.14 16a4.813 4.813 0 0 1-2.14.5zm2.97-5.33a2.969 2.969 0 0 0-2.64-2.64z"
        fill="currentColor"
      />
    </g>
  ),
}))``;

export const ClockIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 14 14',
  children: (
    <g>
      <path data-name="Path 2044" d="M0 0h14v14H0z" fill="none" />
      <path
        data-name="Path 2045"
        d="M7.994 2A6 6 0 1 0 14 8a6 6 0 0 0-6.006-6zM8 12.8A4.8 4.8 0 1 1 12.8 8 4.8 4.8 0 0 1 8 12.8zM7.868 5h-.036a.43.43 0 0 0-.432.432v2.832a.594.594 0 0 0 .294.516l2.49 1.494a.429.429 0 1 0 .438-.738L8.3 8.156V5.432A.43.43 0 0 0 7.868 5z"
        transform="translate(-1 -1)"
        fill="currentColor"
      />
    </g>
  ),
}))``;

export const FolderV2Icon = styled(Icon).attrs(() => ({
  viewBox: '0 0 24 24',
  children: (
    <g>
      <path data-name="Path 3040" d="M0 0h20v20H0z" fill="none" />
      <path
        data-name="Path 3041"
        d="M9.158 4.492A1.672 1.672 0 0 0 7.975 4H3.667a1.664 1.664 0 0 0-1.659 1.667l-.008 10a1.672 1.672 0 0 0 1.667 1.667H17a1.672 1.672 0 0 0 1.667-1.667V7.333A1.672 1.672 0 0 0 17 5.667h-6.667z"
        transform="translate(-.333 -.667)"
        fill="currentColor"
      />
    </g>
  ),
}))``;

export const CancelFileIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 14 14',
  children: (
    <g>
      <path data-name="Path 1991" d="M0 0h14v14H0z" fill="none" />
      <path
        data-name="Path 1992"
        d="M7 2a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm2.5 6.8-.7.7L7 7.7 5.2 9.5l-.7-.7L6.3 7 4.5 5.2l.7-.7L7 6.3l1.8-1.8.7.7L7.7 7z"
        fill="currentColor"
      />
    </g>
  ),
}))``;

export const PreviewFileIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 30 30',
  children: (
    <g>
      <path data-name="Path 2009" d="M0 0h30v30H0z" fill="none" />
      <path
        data-name="Path 2010"
        d="M4.5 4.5h8.75V2H4.5A2.507 2.507 0 0 0 2 4.5v8.75h2.5zM12 15.75 7 22h15l-3.75-5-2.538 3.387zm8.75-5.625A1.875 1.875 0 1 0 18.875 12a1.872 1.872 0 0 0 1.875-1.875zM24.5 2h-8.75v2.5h8.75v8.75H27V4.5A2.507 2.507 0 0 0 24.5 2zm0 22.5h-8.75V27h8.75a2.507 2.507 0 0 0 2.5-2.5v-8.75h-2.5zm-20-8.75H2v8.75A2.507 2.507 0 0 0 4.5 27h8.75v-2.5H4.5z"
        transform="translate(.5 .5)"
        fill="currentColor"
      />
    </g>
  ),
}))``;

export const NoCalendarIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 80 81',
  children: (
    <g>
      <path
        d="M65 10.5H57.5V8C57.5 7.33696 57.2366 6.70107 56.7678 6.23223C56.2989 5.76339 55.663 5.5 55 5.5C54.337 5.5 53.7011 5.76339 53.2322 6.23223C52.7634 6.70107 52.5 7.33696 52.5 8V10.5H27.5V8C27.5 7.33696 27.2366 6.70107 26.7678 6.23223C26.2989 5.76339 25.663 5.5 25 5.5C24.337 5.5 23.7011 5.76339 23.2322 6.23223C22.7634 6.70107 22.5 7.33696 22.5 8V10.5H15C13.6739 10.5 12.4021 11.0268 11.4645 11.9645C10.5268 12.9021 10 14.1739 10 15.5V65.5C10 66.8261 10.5268 68.0979 11.4645 69.0355C12.4021 69.9732 13.6739 70.5 15 70.5H65C66.3261 70.5 67.5979 69.9732 68.5355 69.0355C69.4732 68.0979 70 66.8261 70 65.5V15.5C70 14.1739 69.4732 12.9021 68.5355 11.9645C67.5979 11.0268 66.3261 10.5 65 10.5ZM49.2812 53.7188C49.7507 54.1927 50.0141 54.8329 50.0141 55.5C50.0141 56.1671 49.7507 56.8073 49.2812 57.2812C48.7979 57.7346 48.1626 57.991 47.5 58C46.8361 57.9972 46.1986 57.74 45.7188 57.2812L40 51.5312L34.2812 57.2812C33.7979 57.7346 33.1626 57.991 32.5 58C31.8361 57.9972 31.1986 57.74 30.7188 57.2812C30.2493 56.8073 29.9859 56.1671 29.9859 55.5C29.9859 54.8329 30.2493 54.1927 30.7188 53.7188L36.4688 48L30.7188 42.2812C30.3201 41.7955 30.1164 41.1789 30.1472 40.5512C30.178 39.9236 30.4412 39.3299 30.8855 38.8855C31.3299 38.4412 31.9236 38.178 32.5512 38.1472C33.1789 38.1164 33.7955 38.3201 34.2812 38.7188L40 44.4688L45.7188 38.7188C46.2045 38.3201 46.8211 38.1164 47.4488 38.1472C48.0764 38.178 48.6701 38.4412 49.1145 38.8855C49.5588 39.3299 49.822 39.9236 49.8528 40.5512C49.8836 41.1789 49.6799 41.7955 49.2812 42.2812L43.5312 48L49.2812 53.7188ZM65 25.5H15V15.5H22.5V18C22.5 18.663 22.7634 19.2989 23.2322 19.7678C23.7011 20.2366 24.337 20.5 25 20.5C25.663 20.5 26.2989 20.2366 26.7678 19.7678C27.2366 19.2989 27.5 18.663 27.5 18V15.5H52.5V18C52.5 18.663 52.7634 19.2989 53.2322 19.7678C53.7011 20.2366 54.337 20.5 55 20.5C55.663 20.5 56.2989 20.2366 56.7678 19.7678C57.2366 19.2989 57.5 18.663 57.5 18V15.5H65V25.5Z"
        fill="#9FA3AE"
      />
    </g>
  ),
}))``;

export const CalendarxIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 30 30',
  children: (
    <g>
      <path data-name="Rectangle 6344" fill="transparent" d="M0 0h30v30H0z" />
      <path
        d="M18 19.6a1.307 1.307 0 0 1-.95-.374 1.311 1.311 0 0 1 0-1.852 1.394 1.394 0 0 1 1.9 0 1.311 1.311 0 0 1 0 1.852 1.307 1.307 0 0 1-.95.374zm-5.333 0a1.307 1.307 0 0 1-.95-.374 1.311 1.311 0 0 1 0-1.852 1.394 1.394 0 0 1 1.9 0 1.311 1.311 0 0 1 0 1.852 1.307 1.307 0 0 1-.95.374zm10.667 0a1.307 1.307 0 0 1-.95-.374 1.311 1.311 0 0 1 0-1.852 1.394 1.394 0 0 1 1.9 0 1.311 1.311 0 0 1 0 1.852 1.307 1.307 0 0 1-.951.374zM18 24.8a1.307 1.307 0 0 1-.95-.374 1.311 1.311 0 0 1 0-1.853 1.394 1.394 0 0 1 1.9 0 1.311 1.311 0 0 1 0 1.853 1.307 1.307 0 0 1-.95.374zm-5.333 0a1.307 1.307 0 0 1-.95-.374 1.311 1.311 0 0 1 0-1.853 1.394 1.394 0 0 1 1.9 0 1.311 1.311 0 0 1 0 1.853 1.307 1.307 0 0 1-.95.374zm10.667 0a1.307 1.307 0 0 1-.95-.374 1.311 1.311 0 0 1 0-1.853 1.394 1.394 0 0 1 1.9 0 1.311 1.311 0 0 1 0 1.853 1.307 1.307 0 0 1-.951.374zM8 30a1.943 1.943 0 0 1-1.4-.585A1.849 1.849 0 0 1 6 28.05V7.9a1.849 1.849 0 0 1 .6-1.365A1.943 1.943 0 0 1 8 5.95h2.167V4h2.167v1.95h11.333V4h2.167v1.95H28a1.943 1.943 0 0 1 1.4.585A1.849 1.849 0 0 1 30 7.9v20.15a1.849 1.849 0 0 1-.6 1.365A1.943 1.943 0 0 1 28 30zm0-1.95h20V14.075H8V28.05zm0-15.925h20V7.9H8zm0 0V7.9z"
        transform="translate(-3 -2)"
        fill="currentColor"
      />
    </g>
  ),
}))``;

export const DollarCircleIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 20 20',
  children: (
    <g>
      <g data-name="Group 19984">
        <path data-name="Rectangle 6278" d="M0 0h20v20H0z" fill="none" />
      </g>
      <g data-name="Group 19985">
        <path
          data-name="Path 3042"
          d="M10.333 2a8.333 8.333 0 1 0 8.333 8.333A8.336 8.336 0 0 0 10.333 2zm.733 13.133v.3a.734.734 0 0 1-.733.733.734.734 0 0 1-.733-.733v-.35a3.341 3.341 0 0 1-2.242-1.75.718.718 0 0 1 .375-.983l.058-.025a.709.709 0 0 1 .9.325 1.95 1.95 0 0 0 1.767 1.142c.775 0 1.65-.4 1.65-1.342 0-.8-.583-1.217-1.9-1.692C9.292 10.433 7.417 9.9 7.417 8A2.565 2.565 0 0 1 9.6 5.533v-.3a.734.734 0 0 1 .733-.733.734.734 0 0 1 .733.733v.308a2.824 2.824 0 0 1 1.8 1.083.708.708 0 0 1-.3 1.083.728.728 0 0 1-.85-.233 1.584 1.584 0 0 0-1.333-.642c-.583 0-1.508.308-1.508 1.158 0 .792.717 1.092 2.2 1.583 2 .692 2.508 1.708 2.508 2.875a2.763 2.763 0 0 1-2.516 2.685z"
          transform="translate(-.333 -.333)"
          fill="currentColor"
        />
      </g>
    </g>
  ),
}))``;

export const CloseFillIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 20 20',
  children: (
    <g>
      <path
        data-name="Path 3047"
        d="M0 0h20v20H0z"
        fill="none"
        opacity="0.87"
      />
      <path
        data-name="Path 3048"
        d="M10.333 2a8.333 8.333 0 1 0 8.333 8.333A8.326 8.326 0 0 0 10.333 2zm3.583 11.917a.83.83 0 0 1-1.175 0l-2.408-2.408-2.408 2.408a.831.831 0 0 1-1.175-1.175l2.408-2.408L6.75 7.925A.831.831 0 0 1 7.925 6.75l2.408 2.408 2.409-2.408a.831.831 0 1 1 1.175 1.175l-2.408 2.408 2.408 2.408a.845.845 0 0 1 0 1.175z"
        transform="translate(-.333 -.333)"
        fill="currentColor"
      />
    </g>
  ),
}))``;

export const MinimalArrowDownIcon = styled(Icon).attrs(() => ({
  children: (
    <g>
      <g>
        <path data-name="Path 2017" d="M0 18h18V0H0z" fill="none" />
      </g>
      <g>
        <path
          data-name="Path 2018"
          d="M10.069 13.137 6.627 9.694a.748.748 0 0 1 1.057-1.057l2.918 2.91 2.91-2.91a.748.748 0 1 1 1.057 1.058l-3.442 3.442a.747.747 0 0 1-1.058 0z"
          transform="translate(-1.602 -1.669)"
          fill="currentColor"
        />
      </g>
    </g>
  ),
}))``;

export const ExportIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 20 20',
  children: (
    <g data-name="Group 19516">
      <path
        data-name="Icon awesome-file-export"
        d="M7.778 2.778a.582.582 0 0 0-.142-.385L5.654.16A.46.46 0 0 0 5.309 0h-.123v2.917h2.592zm3.788 4.241-1.939-2.2a.322.322 0 0 0-.555.257v1.487h-1.3v1.458h1.3v1.486a.322.322 0 0 0 .555.257l1.939-2.2a.423.423 0 0 0 0-.546zm-7.677.638v-.73a.347.347 0 0 1 .324-.365h3.565V3.646H5.024a.521.521 0 0 1-.487-.546V0H.486A.518.518 0 0 0 0 .547V11.12a.518.518 0 0 0 .486.547h6.806a.518.518 0 0 0 .486-.547v-3.1H4.213a.347.347 0 0 1-.324-.364z"
        transform="translate(4.728 4.211)"
        fill="currentColor"
      />
    </g>
  ),
}))``;

export const AllCheckIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 16 16',
  children: (
    <g>
      <g>
        <path data-name="Path 2094" d="M0 0h16v16H0z" fill="none" />
      </g>
      <g>
        <path
          data-name="Path 2095"
          d="M11.809 6.2a.664.664 0 0 0-.94 0l-3.76 3.76.94.94 3.76-3.767a.668.668 0 0 0 0-.933zm2.827-.007L8.049 12.78l-2.32-2.313a.665.665 0 0 0-.94.94l2.787 2.787a.664.664 0 0 0 .94 0l7.06-7.053a.664.664 0 0 0 0-.94h-.007a.65.65 0 0 0-.933-.007zm-13.614 5.22L3.809 14.2a.664.664 0 0 0 .94 0l.467-.467-3.254-3.267a.664.664 0 0 0-.94 0 .672.672 0 0 0 0 .947z"
          transform="translate(-.276 -2)"
          fill="currentColor"
        />
      </g>
    </g>
  ),
}))``;

export const ArrowLeftIcon = styled(Icon).attrs(() => ({
  viewBox: '0 0 32 32',
  children: (
    <g>
      <path data-name="Path 2003" d="M0 0h32v32H0z" fill="none" />
      <path
        data-name="Path 20154"
        d="M28 16.005a1 1 0 0 1-1 1H7.414l7.292 7.288a1 1 0 1 1-1.413 1.412l-9-9a1 1 0 0 1 0-1.415l9-9a1 1 0 1 1 1.413 1.415l-7.292 7.3H27a1 1 0 0 1 1 1z"
      />
    </g>
  ),
}))``;
